import { useMemo } from "react";

/**
 * Велика іконка поля з GeoJSON Polygon.
 * Контур завжди повністю вміщується.
 */
export default function FieldShapeIcon({ geometry, size = 72 }) {
  const pathD = useMemo(() => {
    try {
      if (!geometry) return null;

      const g = typeof geometry === "string" ? JSON.parse(geometry) : geometry;
      if (!g || g.type !== "Polygon" || !Array.isArray(g.coordinates)) return null;

      const ring = g.coordinates?.[0];
      if (!Array.isArray(ring) || ring.length < 3) return null;

      let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;

      for (const p of ring) {
        const x = Number(p?.[0]);
        const y = Number(p?.[1]);
        if (!Number.isFinite(x) || !Number.isFinite(y)) continue;

        minX = Math.min(minX, x);
        maxX = Math.max(maxX, x);
        minY = Math.min(minY, y);
        maxY = Math.max(maxY, y);
      }

      if (!Number.isFinite(minX) || maxX - minX === 0 || maxY - minY === 0)
        return null;

      const pad = 10;        // 🔥 більший внутрішній відступ
      const W = 120;
      const H = 120;

      const normX = (x) =>
        ((x - minX) / (maxX - minX)) * (W - pad * 2) + pad;

      const normY = (y) =>
        (H - pad) -
        ((y - minY) / (maxY - minY)) * (H - pad * 2);

      let d = "";

      ring.forEach((p, i) => {
        const x = normX(p[0]);
        const y = normY(p[1]);
        d += `${i === 0 ? "M" : "L"} ${x.toFixed(2)} ${y.toFixed(2)} `;
      });

      d += "Z";
      return d;
    } catch {
      return null;
    }
  }, [geometry]);

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: 18,
        border: "1px solid rgba(255,255,255,0.15)",
        background: "rgba(255,255,255,0.04)",
        display: "grid",
        placeItems: "center",
        overflow: "hidden",
        flex: "0 0 auto"
      }}
    >
      {pathD ? (
        <svg
          viewBox="0 0 120 120"
          style={{ width: "100%", height: "100%" }}
          preserveAspectRatio="xMidYMid meet"
        >
          <path
            d={pathD}
            fill="rgba(34,197,94,0.25)"
            stroke="rgba(34,197,94,0.95)"
            strokeWidth="4"
          />
        </svg>
      ) : (
        <div style={{ fontSize: 14, opacity: 0.7 }}>—</div>
      )}
    </div>
  );
}
